import {
    Action,
    ActionReducer,
    ActionReducerMap,
    MetaReducer,
    State
} from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { environment } from '../../../environments/environment';
import { AccountState } from './../../accounts/store/account/account.entity';
import { authActionTypes } from './../../auth/store/auth.actions';
// import { AccountState, IrrigationState } from './../../irrigation/store/irrigation.entity';
import { AuthState } from './../../auth/store/auth.entity';
// import { LightingState } from './../../lighting/store/lighting.entity';
import { AdminState } from '../../admin/store/admin.entity';
import * as fromIrrigation from '../../irrigation/store/irrigation.reducer';
import * as fromAccount from './../../accounts/store/account/account.reducers';
import { ToroLocationState } from './../../accounts/store/toro-location/toro-location.entity';
import * as fromLocation from './../../accounts/store/toro-location/toro-location.reducers';
import * as fromAdmin from './../../admin/store/admin.reducer';
import * as fromAuth from './../../auth/store/auth.reducers';
import { IrrigationState } from './../../irrigation/store/irrigation.entity';
import { LightingState } from './../../lighting/store/lighting.entity';
import * as fromLighting from './../../lighting/store/lighting.reducer';

import merge from 'lodash.merge';
const INIT_ACTION = "@ngrx/store/init";
const UPDATE_ACTION = "@ngrx/store/update-reducers";



export interface AppState //implements LocationState, LightingState
{
    authState: AuthState,
    locationState: ToroLocationState,
    accountState: AccountState,
    lightingState: LightingState,
    irrigationState: IrrigationState,
    adminState:AdminState
}

export const reducers: ActionReducerMap<AppState> = {
    authState: fromAuth.authReducerFn,
    locationState: fromLocation.toroLocationReducer,
    accountState: fromAccount.accountReducer,
    lightingState: fromLighting.lightingReducer,
    irrigationState: fromIrrigation.irrigationReducer,
    adminState:fromAdmin.adminReducer
};

const mergeReducer = (state: State<AppState>, rehydratedState: State<AppState>, action: Action): State<AppState> => {
    if ((action.type === INIT_ACTION || action.type === UPDATE_ACTION) && rehydratedState) {
        state = merge(state, rehydratedState);
    }

    return state;
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return localStorageSync({
        keys: [
            'LastNotificationIds',
            'SelectedLocationId',
            'AccessToken',
            'RememberMe',
            'SelectedAccountId',
            'FwUpdateCancelled',
            'CurrentUser',
            'account',
            'authState',
            'UserId',
            'EmailAddress',
            'DetailedAccounts',
            'appCommon',
            'accountState',
            'locationState',
            'lightingState',
            'irrigationState',
            'adminState'
        ],
        rehydrate: true,
        mergeReducer
    })(reducer);
}

export function clearStateMetaReducer<State extends {}>(reducer: ActionReducer<State>): ActionReducer<State> {
    return function clearStateFn(state: State, action: Action) {
        if (action.type === authActionTypes.LogOut.type) {
            state = {} as State; // ==> Emptying state here
        }
        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [localStorageSyncReducer, clearStateMetaReducer] : [localStorageSyncReducer, clearStateMetaReducer];
